import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";

export const SET_POST_FTUX_MESSAGE_TYPE = "set_post_ftux";

type SetPostFtuxInfo = {
  user_id: string;
  onboarding_complete: boolean;
};

export const setPostFtux = (info: SetPostFtuxInfo) =>
  SocketAsFetch.fetch({
    message_type: SET_POST_FTUX_MESSAGE_TYPE,
    info,
  });
